import List from './CoOrdinatorList'
import Register from './RegisterCoOrdinator'

const exportObj = {
    List,
    Register
}

export default exportObj